import React from "react";

/**
 * Map any status string → semantic tone for theme-based chips.
 */
export function getStatusTone(status) {
  const s = String(status || "")
    .toUpperCase()
    .trim()
    .replace(/\s+/g, "_");

  if (
    [
      "SUCCESS",
      "SUCCESSFUL",
      "ACTIVE",
      "ENABLED",
      "VERIFIED",
      "CREDIT",
      "REFUNDED",
      "COMPLETED",
      "APPROVED",
    ].includes(s)
  ) {
    return "success";
  }

  if (
    [
      "INITIATED",
      "PROCESSING",
      "IN_PROGRESS",
      "OTP_SENT",
      "REVERSED",
      "REFUND",
      "REGISTERED",
      "DOC_UPLOADED",
    ].includes(s)
  ) {
    return "info";
  }

  if (
    [
      "PENDING",
      "REFUND_PENDING",
      "RECONCILIATION_REQUIRED",
      "HOLD",
      "PENDING_DOC_UPLOAD",
      "PENDING_DOC_VERIFICATION",
      "ONBOARDING_PENDING",
      "SUSPENDED",
    ].includes(s)
  ) {
    return "warning";
  }

  if (
    [
      "FAILED",
      "FAILURE",
      "FAIELD",
      "REJECTED",
      "INACTIVE",
      "DISABLED",
      "DEBIT",
      "CANCELLED",
      "CANCELED",
      "BLOCKED",
      "EXPIRED",
      "ERROR",
    ].includes(s)
  ) {
    return "error";
  }

  return "neutral";
}

/**
 * Theme-based status chip: bg + text + light border by status.
 */
const StatusBadge = ({ status, label, className = "" }) => {
  const value = status ?? label;
  if (value == null || value === "" || value === "--") {
    return <span className="text-[var(--text-muted)]">--</span>;
  }
  const tone = getStatusTone(value);
  const text = String(label ?? value).replace(/_/g, " ");

  return (
    <span
      className={`ds-status ds-status-${tone} ${className}`.trim()}
      title={text}
    >
      {text}
    </span>
  );
};

export default StatusBadge;
